import { createAction, createAsyncThunk, createSelector, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'store/store';
import { IUsersListState } from './interfaces';
import { getRequest } from 'api/requests';

export const setQuery = createAction('usersList/setQuery', (query: string) => ({
	payload: query,
}));

export const fetchUsers = createAsyncThunk(
	'usersList/fetchUsers',
	async (_, { rejectWithValue }) => {
		try {
			const { data } = await getRequest(`user/all`);

			return data || [];
		} catch (error) {
			return rejectWithValue(error);
		}
	},
);

const initialState: IUsersListState = {
	isLoading: false,
	items: [],
	query: '',
};

const usersListSlice = createSlice({
	name: 'usersList',
	initialState,
	reducers: {
		setQuery: (state, { payload }) => ({
			...state,
			query: payload.toLocaleLowerCase(),
		}),
	},
	extraReducers: (builder) => {
		builder
			.addCase(fetchUsers.pending, (state) => ({
				...state,
				isLoading: true,
			}))
			.addCase(fetchUsers.rejected, (state) => ({
				...state,
				isLoading: false,
			}))
			.addCase(fetchUsers.fulfilled, (state, { payload }) => ({
				...state,
				isLoading: false,
				items: payload,
			}));
	},
});

// Селекторы
export const UsersListSelector = (state: RootState): IUsersListState => state.usersList;

export const UsersListLoadingSelector = createSelector(
	UsersListSelector,
	({ isLoading }) => isLoading,
);

export const UsersListItemsSelector = createSelector(UsersListSelector, ({ items }) => items);

export const QuerySelector = createSelector(UsersListSelector, ({ query }) => query);

export default usersListSlice.reducer;
